import React, { createContext, useContext } from 'react';
import { useSelectedServices, SelectedService } from '@/hooks/use-selected-services';

interface ServiceSelectionContextType {
  selectedServices: SelectedService[];
  addService: (id: string, name: string) => void;
  removeService: (id: string) => void;
  clearServices: () => void;
  getMessageText: () => string;
  getServicesCSV: () => string;
}

const ServiceSelectionContext = createContext<ServiceSelectionContextType | undefined>(undefined);

export const ServiceSelectionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const serviceSelection = useSelectedServices();

  return (
    <ServiceSelectionContext.Provider value={serviceSelection}>
      {children}
    </ServiceSelectionContext.Provider>
  );
};

export const useServiceSelection = () => {
  const context = useContext(ServiceSelectionContext);
  if (context === undefined) {
    throw new Error('useServiceSelection must be used within a ServiceSelectionProvider');
  }
  return context;
};